import {
  END_RESEQUENCING_FLOW,
  INITIALIZE_RESEQUENCING_FLOW,
  SET_ACTIVE_DATE,
} from './actionTypes';

const initializeResequenceFlowForDateRange = (startDate, endDate) => ({
  type: INITIALIZE_RESEQUENCING_FLOW,
  startDate,
  endDate,
});

const setActiveDate = activeDate => ({
  type: SET_ACTIVE_DATE,
  activeDate,
});

const endResequencingFlow = () => ({
  type: END_RESEQUENCING_FLOW,
});

export default {
  initializeResequenceFlowForDateRange,
  setActiveDate,
  endResequencingFlow,
};
